import { render } from "./footer.vue?vue&type=template&id=6822d916&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=6822d916&lang=less&scoped=true"
import "./footer.vue?vue&type=style&index=1&id=6822d916&lang=css"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6822d916"]])

export default __exports__